import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { Observable, Subscription } from "rxjs";

import * as model from "../../models";
import { Category, Event, TicketQuota, Venue } from "../../models";
import * as ui from "../../models/ui"
import { MerchantApi, TicketCreationDTO } from "../../services/webservice"
import { TicketQuotaHandlingService } from '../../services';
import { ShoppingCartActions } from "../shopping-cart/shopping-cart.actions"


@Component({
	selector: 'event-tickets',
	templateUrl: "./event-tickets.html",
	styles: [require("./event-tickets.scss")],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class EventTickets implements OnDestroy {

	ticketQuotas$: Observable<TicketQuota[]>
	private event$: Observable<Event>;
	private venue$: Observable<Venue>;
	private displayCategories$: Observable<ui.DisplayCategory[]>;

	private selectedTicketQuota: TicketQuota;
	private shoppingCart: model.ShoppingCart;
	private showTicketQuotaDropDown: boolean = true;
	private tqSubscription: Subscription;

	constructor(
		private store: Store<AppState>,
		private route: ActivatedRoute,
		private shoppingCartActions: ShoppingCartActions,
		private merchantApi: MerchantApi
	) {}

	ngOnInit() {
		this.store.select("shoppingCart", "shoppingCart").subscribe(data => {
			this.shoppingCart = data
		})
		this.event$ = this.store.select("eventServerState", "event", "currentEvent");
		this.venue$ = this.store.select("venuesState", "currentVenue");
		this.ticketQuotas$ = this.store.select("eventServerState", "ticketQuotas", "ticketQuotaCollection").map((ticketQuotas: TicketQuota[]) => {
			return ticketQuotas.filter((tq: TicketQuota) => tq.allowedBookingOfficeUUIDs.indexOf(this.merchantApi.getBookingOfficeUuid()) > -1)
		});

		this.tqSubscription = this.ticketQuotas$.subscribe(data => {
			if (data.length === 1) {
				this.showTicketQuotaDropDown = false;
			}
			this.selectedTicketQuota = TicketQuotaHandlingService.getStandardTicketQuotaOrFirstOrNull(data);
		})

		let categories$ = this.store.select("eventServerState", "categories", "categories")
		let combinedPricelevels$ = this.store.select("eventServerState", "priceLevels", "combinedPricelevels")
		this.displayCategories$ = Observable.combineLatest(
			categories$,
			combinedPricelevels$,
			(categories, combinedPricelevels) => this.mergeCategoryWithCombinedPriceLevel(categories, combinedPricelevels)
		)
	}

	ngOnDestroy(): void {
		this.tqSubscription.unsubscribe();
	}

	createTickets(ticketCreationDTOs: TicketCreationDTO[]) {
		this.store.dispatch(this.shoppingCartActions.addTickets(this.shoppingCart._links.tickets.href, ticketCreationDTOs))
	}

	private mergeCategoryWithCombinedPriceLevel(categories: Category[], combinedPriceLevels: ui.CombinedPriceLevel[]): ui.DisplayCategory[] {
		let results: ui.DisplayCategory[] = []
		for (let category of categories) {
			let foundCombinedPriceLevel = combinedPriceLevels.find(cpl => cpl.categoryID === category.uuid)
			results.push({
				category: category,
				combinedPriceLevel: foundCombinedPriceLevel
			})
		}
		return results;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/event-tickets/event-tickets.component.ts